import { render, staticRenderFns } from "./detail_disk.vue?vue&type=template&id=05625e54&scoped=true&"
import script from "./detail_disk.vue?vue&type=script&lang=js&"
export * from "./detail_disk.vue?vue&type=script&lang=js&"
import style0 from "./detail_disk.vue?vue&type=style&index=0&id=05625e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05625e54",
  null
  
)

export default component.exports